import React from "react";
import { createFileRoute } from "@tanstack/react-router";
import { z } from "zod";

const tokenSchema = z.object({
  token_name: z.string().optional(),
  payment_session_id: z.string().optional(),
});

export const Route = createFileRoute("/$lang/payment-processing")({
  component: React.lazy(() =>
    import("@/pages/payment-processing").then((mod) => ({
      default: mod.PaymentProcessing,
    })),
  ),
  validateSearch: (search) => tokenSchema.parse(search),
});
